import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import {RefreshTaskType} from '../requests/CreateSelfServiceScheduleExtractTasksRequest';
import { SelfServiceSchedule } from '../types/SelfServiceSchedule';

export interface SetExtractTasksSelfServiceScheduleRequestParams {
    schedule: SelfServiceSchedule;
    type: RefreshTaskType;
    scheduleName: string;
    ids: number[];
}

export class SetExtractTasksSelfServiceScheduleRequest extends Request<SetExtractTasksSelfServiceScheduleRequestParams, IResult> {
    constructor(params: SetExtractTasksSelfServiceScheduleRequestParams) {
        super('setExtractTasksSelfServiceSchedule', params);
    }
}